import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next@15.5.20_@playwright+test@1.57.0_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/app-dir/link.js");
